import FinancialInstitutions from '@domains/super-admins/financial-institutions/views/FinancialInstitutions.vue'
import GiftCard from '@domains/super-admins/gift-card/views/GiftCard.vue'
import Holidays from '@domains/super-admins/holidays/views/Holidays.vue'
import Newsletter from '@domains/super-admins/newsletter/views/Newsletter.vue'
import Parameters from '@domains/super-admins/parameters/views/Parameters.vue'
import PlatformAlert from '@domains/super-admins/platform-alert/views/PlatformAlert.vue'
import PromoCodes from '@domains/super-admins/promo-codes/views/PromoCodes.vue'
import PushNotification from '@domains/super-admins/push-notification/views/PushNotification.vue'
import Users from '@domains/super-admins/users/views/Users.vue'

import Layout from '@/container/Layout.vue'

export default [
  {
    path: 'super-admins',
    component: Layout,
    children: [
      {
        path: 'holidays',
        component: Holidays,
        name: 'Holidays'
      },
      {
        path: 'push-notification',
        component: PushNotification,
        name: 'PushNotification'
      },
      {
        path: 'newsletter',
        component: Newsletter,
        name: 'Newsletter'
      },
      {
        path: 'promo-codes',
        component: PromoCodes,
        name: 'PromoCodes'
      },
      {
        path: 'parameters',
        component: Parameters,
        name: 'Parameters'
      },
      {
        path: 'gift-card',
        component: GiftCard,
        name: 'GiftCard'
      },
      {
        path: 'platform-alert',
        component: PlatformAlert,
        name: 'PlatformAlert'
      },
      {
        path: 'users',
        component: Users,
        name: 'Users',
        props: (route) => ({
          search: route.query.search
        })
      },
      {
        path: 'financial-institutions',
        component: FinancialInstitutions,
        name: 'FinancialInstitutions'
      }
    ]
  }
]
